/**
 * Specifies pivot external events
 * @hidden
 */
/** @hidden */
export var load = 'load';
/** @hidden */
export var enginePopulating = 'enginePopulating';
/** @hidden */
export var enginePopulated = 'enginePopulated';
/** @hidden */
export var onFieldDropped = 'onFieldDropped';
/** @hidden */
export var fieldDrop = 'fieldDrop';
/** @hidden */
export var beforePivotTableRender = 'beforePivotTableRender';
/** @hidden */
export var afterPivotTableRender = 'afterPivotTableRender';
/** @hidden */
export var beforeExport = 'beforeExport';
/** @hidden */
export var excelHeaderQueryCellInfo = 'excelHeaderQueryCellInfo';
/** @hidden */
export var pdfHeaderQueryCellInfo = 'pdfHeaderQueryCellInfo';
/** @hidden */
export var excelQueryCellInfo = 'excelQueryCellInfo';
/** @hidden */
export var pdfQueryCellInfo = 'pdfQueryCellInfo';
/** @hidden */
export var onPdfCellRender = 'onPdfCellRender';
/** @hidden */
export var dataBound = 'dataBound';
/** @hidden */
export var queryCellInfo = 'queryCellInfo';
/** @hidden */
export var headerCellInfo = 'headerCellInfo';
/** @hidden */
export var hyperlinkCellClick = 'hyperlinkCellClick';
/** @hidden */
export var resizing = 'resizing';
/** @hidden */
export var resizeStop = 'resizeStop';
/** @hidden */
export var cellClick = 'cellClick';
/** @hidden */
export var drillThrough = 'drillThrough';
/** @hidden */
export var beforeColumnsRender = 'beforeColumnsRender';
/** @hidden */
export var selected = 'selected';
/** @hidden */
export var cellSelecting = 'cellSelecting';
/** @hidden */
export var drill = 'drill';
/** @hidden */
export var cellSelected = 'cellSelected';
/** @hidden */
export var cellDeselected = 'cellDeselected';
/** @hidden */
export var rowSelected = 'rowSelected';
/** @hidden */
export var rowDeselected = 'rowDeselected';
/** @hidden */
export var beginDrillThrough = 'beginDrillThrough';
/** @hidden */
export var saveReport = 'saveReport';
/** @hidden */
export var fetchReport = 'fetchReport';
/** @hidden */
export var loadReport = 'loadReport';
/** @hidden */
export var renameReport = 'renameReport';
/** @hidden */
export var removeReport = 'removeReport';
/** @hidden */
export var newReport = 'newReport';
/** @hidden */
export var toolbarRender = 'toolbarRender';
/** @hidden */
export var toolbarClick = 'toolbarClick';
/** @hidden */
export var chartTooltipRender = 'chartTooltipRender';
/** @hidden */
export var chartLoaded = 'chartLoaded';
/** @hidden */
export var chartLoad = 'chartLoad';
/** @hidden */
export var chartResized = 'chartResized';
/** @hidden */
export var chartAxisLabelRender = 'chartAxisLabelRender';
/** @hidden */
export var chartSeriesCreated = 'chartSeriesCreated';
/** @hidden */
export var aggregateCellInfo = 'aggregateCellInfo';
/** @hidden */
export var contextMenuClick = 'contextMenuClick';
/** @hidden */
export var contextMenuOpen = 'contextMenuOpen';
/** @hidden */
export var fieldListRefreshed = 'fieldListRefreshed';
/** @hidden */
export var conditionalFormatting = 'conditionalFormatting';
/** @hidden */
export var beforePdfExport = 'beforePdfExport';
/** @hidden */
export var beforeExcelExport = 'beforeExcelExport';
/** @hidden */
export var memberFiltering = 'memberFiltering';
/** @hidden */
export var calculatedFieldCreate = 'calculatedFieldCreate';
/** @hidden */
export var memberEditorOpen = 'memberEditorOpen';
/** @hidden */
export var fieldRemove = 'fieldRemove';
/** @hidden */
export var numberFormatting = 'numberFormatting';
/** @hidden */
export var aggregateMenuOpen = 'aggregateMenuOpen';
/** @hidden */
export var fieldDragStart = 'fieldDragStart';
/** @hidden */
export var chartPointClick = 'chartPointClick';
/**
 * Specifies pivot internal events
 */
/** @hidden */
export var initialLoad = 'initial-load';
/** @hidden */
export var uiUpdate = 'ui-update';
/** @hidden */
export var scroll = 'scroll';
/** @hidden */
export var contentReady = 'content-ready';
/** @hidden */
export var dataReady = 'data-ready';
/** @hidden */
export var initSubComponent = 'init-groupingbar';
/** @hidden */
export var treeViewUpdate = 'tree-view-update';
/** @hidden */
export var pivotButtonUpdate = 'pivot-button-update';
/** @hidden */
export var initCalculatedField = 'init-calculatedfield';
/** @hidden */
export var click = 'click';
/** @hidden */
export var initToolbar = 'init-toolbar';
/** @hidden */
export var initFormatting = 'init-formatting';
/** @hidden */
export var initGrouping = 'init-grouping';
